import React from 'react';
import {View} from 'react-native';

import Screen from '../../../../../shared/components/screen';

import {Props} from './model';
import {useStyles} from '../../../../../shared/hooks/styles';
import {EvenOddList} from '../../../../../shared/components/evenOddList';
import {CustomScrollView} from '../../../../../shared/components/scrollView';

export default ({addresses, email, phone}: Props) => {
  const styles = useStyles(({theme}) => {
    return {
      container: {
        paddingBottom: theme.screen.bottomOffset,
      },
      sectionContainer: {
        marginTop: 21,
        paddingHorizontal: 24,
      },
      sectionTitle: theme.fonts.h2,
      body: theme.fonts.body,
      iconColor: {
        color: theme.color.textColor,
      },
      phoneContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        height: 40,
      },
    };
  });

  return (
    <Screen>
      <CustomScrollView contentInsetAdjustmentBehavior='automatic' contentContainerStyle={styles.container}>
        <View>
          <View style={styles.sectionContainer}>
            <EvenOddList testIDPrefix='adresses-list' list={addresses} title='Адрес' hasPrivateData />
          </View>
          <View style={styles.sectionContainer}>
            <EvenOddList testIDPrefix='phone-list' list={phone} title='Телефон' />
          </View>
          <View style={styles.sectionContainer}>
            <EvenOddList testIDPrefix='mails-list' list={email} title='Электронная почта' />
          </View>
        </View>
      </CustomScrollView>
    </Screen>
  );
};
